// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".computed-wrapper[data-v-6da8c3b6] {\n  background-color: #fffbe5;\n}\n.unaffected-config[data-v-6da8c3b6] {\n  color: #A6A4A6;\n}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
